import { cn } from '@/lib/utils'
import { Award, ShieldAlert, Sparkles } from 'lucide-react'

export function ConfidenceBadge({ score }: { score: number | null | undefined }) {
  if (score == null) return null

  let labelText = 'Baja'
  let colorClass = 'border-danger/30 text-danger bg-danger-soft/20'
  let Icon = ShieldAlert

  if (score >= 80) {
    labelText = 'Muy Alta'
    colorClass = 'border-brand/40 text-brand bg-brand-soft/40 shadow-[0_0_12px_rgba(167,237,32,0.06)]'
    Icon = Sparkles
  } else if (score >= 65) {
    labelText = 'Alta'
    colorClass = 'border-brand/30 text-brand bg-brand-soft/30'
    Icon = Award
  } else if (score >= 45) {
    labelText = 'Media'
    colorClass = 'border-warn/30 text-warn bg-warn-soft/20'
    Icon = Award
  } else if (score >= 25) {
    labelText = 'Baja'
    colorClass = 'border-danger/20 text-danger/80 bg-danger-soft/10'
    Icon = ShieldAlert
  } else {
    labelText = 'Muy Baja'
    colorClass = 'border-danger/30 text-danger bg-danger-soft/20'
    Icon = ShieldAlert
  }

  return (
    <div className="flex flex-col items-start gap-1">
      <span className="text-[9px] uppercase font-bold tracking-wider text-text-dim">
        Confianza
      </span>
      <span
        className={cn(
          'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-xl text-[10px] font-bold uppercase tracking-wider border whitespace-nowrap',
          colorClass
        )}
      >
        <Icon className="h-3.5 w-3.5 shrink-0" />
        {/* Sprint "Corrección Final Product Experience V2" (10/09/2026, Sección 4 del
            encargo): BUG REAL corregido -- mostrar el score numérico junto a la etiqueta
            ("Media (67.5%)") hacía que el cliente confundiera Confianza (solidez de la
            evidencia) con Probabilidad JA (estimación real de ocurrencia). Cliente ve SOLO
            la etiqueta cualitativa -- nunca el porcentaje técnico. */}
        <span>{labelText}</span>
      </span>
    </div>
  )
}
